export default {
  tutorPart: ({ plural, named }) =>
    plural([
      "Sie sind Betreuer bei <strong>einer</strong> Ausbildung",
      `Sie sind Betreuer bei <strong>${named("number")}</strong> Ausbildungen`,
    ]),
  studeaManagerPart: ({ plural, named }) =>
    plural([
      "Sie sind derzeit Admin bei <strong>einer</strong> Ausbildung",
      `Sie sind derzeit Admin bei <strong>${named("number")}</strong> Ausbildungen`,
    ]),
  apprenticeMasterPart: ({ plural, named }) =>
    plural([
      "Sie sind derzeit Ausbildungsmeister bei <strong>einer</strong> Ausbildung",
      `Sie sind derzeit Ausbildungsmeister bei <strong>${named("number")}</strong> Ausbildungen`,
    ]),
  promotion: "Gruppe",
  "Training courses list": "Liste der Ausbildungen",
  loadingTrainingCourses: "Ausbildungen werden geladen...",
  trainingCourseInfos: "Informationen zur Ausbildung",
  "Useful links": "Nützliche Links",
  trainingCoursesSelected: "Ausgewählte Ausbildungen",
  badgeFiltersLabel: "Nach Funktion filtern",
  badgeFiltersResultsCount: ({ plural, named }) =>
    plural(["Keine Ergebnisse", `${named("count")} Ergebnis`, `${named("count")} Ergebnisse`]),
  year: "Jahr",
  training_course: {
    errors: {
      start_year_upper_than_end_year: "Das Startjahr muss kleiner als das Endjahr sein",
      month_duration_too_long:
        "Die Dauer in Monaten muss kleiner oder gleich der Differenz zwischen End- und Startjahr sein",
    },
  },
  user_already_studea_manager_on_training_course: "Dieser Benutzer ist bereits Pilot in dieser Gruppe",
  trainingCourse_document: {
    planning: "Planung",
    program: "Programm",
    rncpSheet: "RNCP-Blatt",
    job_description: "Personalisiertes Aufgabenbeschreibungsformular",
  },
  see_archive_training_courses: "Archivierte Gruppen anzeigen",
};
